/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, Alert } from "@mui/material";
import { useAuth } from "../../../../../auth/auth";
import { CheckWorkersShiftCounts, GetDuplicateUsers, getRoles, mergeUserJobs } from "../../../../../api/apiCall";
import { Checkbox } from "antd";
import { toast } from "react-toastify";
import AccessForbidden from "../../../../Access/AccessForbidden";
import Loading from "../../../../../components/Loading/Loading";

const Duplicates = () => {
    const { state } = useAuth();
    const [workers, setWorkers] = useState<any>([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedUserDuplicates, setSelectedUserDuplicates] = useState<any[]>([]);
    const [counts, setCounts] = useState([]);
    const [originalUserId, setOriginalUserId] = useState(null);
    const [duplicateUserId, setDuplicateUserId] = useState(null);
    const [result, setResult] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [roles, setRoles] = useState<any>([]);

    const getWorkers = async () => {
        const response: any = await GetDuplicateUsers(state.user?.token);
        setWorkers(response.data || []);
    };

    const handleOpenModal = (user: any) => {
        setSelectedUserDuplicates(user.duplicates || []);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedUserDuplicates([]);
        setOriginalUserId(null);
        setDuplicateUserId(null);
    };

    const handleClickEdit = (userId: any) => {
        const url = `/pace-team/resourcing/profile?workerId=${userId}`;
        window.open(url, "_blank");
    };

    const columns: any = [
        { field: "pts", headerName: "PTS", flex: 1, headerAlign: "center", align: "center" },
        { field: "duplicateCount", headerName: "Duplicate Counts", flex: 1, headerAlign: "center", align: "center" },
        {
            field: "details",
            headerName: "Details",
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: (params: any) => (
                <Button
                    variant="contained"
                    onClick={() => {handleOpenModal(params.row); setSelectedUserDuplicates(params.row.users)}}
                    style={{
                        boxShadow: "none",
                        backgroundColor: "#6c757d",
                    }}
                >
                    Details
                </Button>
            ),
        },
    ];

    const shiftCounts = async () => {
        const response = await CheckWorkersShiftCounts(state.user?.token, selectedUserDuplicates);
        setCounts(response.data);
    }

    useEffect(() => {
        getWorkers();
    }, []);

    useEffect(() => {
        if(openModal) {    
            shiftCounts()
        }
    }, [openModal]);

    const rowsWithId = workers.map((row: any, index: any) => ({
        id: index,
        ...row
    }));

    const mergedUsers = Object.values(
        [...selectedUserDuplicates, ...counts].reduce((acc: any, curr: any) => {
            if (!acc[curr.id]) {
                acc[curr.id] = { ...curr };
            } else {
                acc[curr.id] = {
                    ...acc[curr.id],
                    ...curr,
                };
            }
            return acc;
        }, {})
    );

    const onChange = (e: any, document: any) => {
        if (e.target.checked) {
            setOriginalUserId(document);
        } else {
            setOriginalUserId(null);
        }
    };

    const onChangeDuplicate = (e: any, document: any) => {
        if (e.target.checked) {
            setDuplicateUserId(document);
        } else {
            setDuplicateUserId(null);
        }
    };

    const mergeUsers = async () => {
        try {
            const response = await mergeUserJobs(state.user?.token, {
                duplicateUserId,
                originalUserId,
            });

            if (response?.success) {
                setResult(response.data);
                shiftCounts();
                setOriginalUserId(null);
                setDuplicateUserId(null);

                setTimeout(() => {
                    setResult(null);
                }, 5000);
            } else {
                toast.info(response?.message || "Merge failed");
            }
        } catch (error: any) {
            console.error("Merge users error:", error);
            toast.error(
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong while merging users"
            );
        }
    };

    const getAllRoles = async () => {
        const response = await getRoles(state.user?.token);
        if(response) {
            setRoles(response);
        }
        else {
            setIsAdmin(true);
        }
        setLoading(false);
    }
    
    useEffect(() => {
        getAllRoles()
    }, []);
    
    if(loading) {
        return <Loading />;
    }
    
    if(isAdmin) {
        return <AccessForbidden />;
    }

    return (
        <>
            <div className="form-content" />
            <Box sx={{ height: "730px", width: "60%", margin: "0 auto" }}>
                <DataGrid
                    rows={rowsWithId}
                    columns={columns}
                    disableRowSelectionOnClick
                    initialState={{
                        pagination: { paginationModel: { pageSize: 100 } },
                    }}
                    pageSizeOptions={[100]}
                    sx={{
                        "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold", fontSize: 15 },
                        "& .MuiDataGrid-columnHeader": { backgroundColor: "#f0f0f0", color: "#000", fontWeight: "bold" },
                    }}
                />
            </Box>
            <Dialog open={openModal} onClose={handleCloseModal} maxWidth="sm" fullWidth>
                <DialogTitle>Duplicated Accounts</DialogTitle>
                <DialogContent>
                    {selectedUserDuplicates.length > 0 ? (
                        <List>
                            {mergedUsers.map((dup: any) => (
                                <ListItem key={dup.id} divider>
                                    O:&nbsp;<Checkbox
                                        onChange={(e) => onChange(e, dup.id)}
                                        checked={originalUserId === dup.id}
                                        style={{marginRight: 20}}
                                    />
                                    D:&nbsp;<Checkbox
                                        onChange={(e) => onChangeDuplicate(e, dup.id)}
                                        checked={duplicateUserId === dup.id}
                                        style={{marginRight: 20}}
                                    />
                                    <ListItemText
                                      primary={`Name: ${dup.fullName || "N/A"} (${dup.count || "N/A"})`}
                                      secondary={`Email: ${dup.email || "N/A"} - Username: ${dup.username || "N/A"} - Phone Number: ${dup.phoneNr}`}
                                    />
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      onClick={() => handleClickEdit(dup.id)}
                                    >
                                      Profile
                                    </Button>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <p>No duplicates found.</p>
                    )}
                </DialogContent>
                {result && (
                    <Alert severity="success">
                        <div>
                            <div><strong>Total found:</strong> {result.totalFound}</div>
                            <div><strong>Total added:</strong> {result.totalAdded}</div>
                            <div><strong>Total skipped:</strong> {result.totalSkipped}</div>
                        </div>
                    </Alert>
                )}
                <DialogActions>
                    <Button onClick={mergeUsers} color="primary">
                        Merge
                    </Button>
                    <Button onClick={handleCloseModal} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Duplicates;
